module.exports = __webpack_public_path__ + "static/img/9.6f0e764.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/9.png
// module id = 8sMQ
// module chunks = 0